import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExcFileItem} from 'exc-upload-v2';
import {environment} from '../../../environments/environment';
import {NestedTreeControl} from '@angular/cdk/tree';
import {ICaseSummaryData} from '../../misc/interfaces/ICaseSummaryData';
import {DataService} from '../../services/data.service';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';

@Component({
  selector: 'app-case-creator',
  templateUrl: './case-creator.component.html',
  styles: [  ],
  animations: [
    trigger('slideInOut', [
      transition('void => false', []),
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),  // Startzustand: Außerhalb des sichtbaren Bereichs
        animate('300ms ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })  // Endzustand: An der richtigen Position
        )
      ]),
      transition('false => void', []),
      transition(':leave', [
        animate('300ms ease-out',
          style({ transform: 'translateY(-100%)', opacity: 0 })  // Verlasse den Bereich nach oben
        )
      ])
    ])
  ]
})
export class CaseCreatorComponent extends ExcTranslation  implements OnInit {
  Data: any = {
    auID: '',
    auUPT: '',
    wert1914Faktor: 0,
    au_enmIdent_AuftragStatus: 0,
    linkedID: undefined
  };
  private _versIsDifferent = false;
  get versIsDifferent(): boolean {
    return this._versIsDifferent;
  }
  set versIsDifferent(value: boolean) {
    this._versIsDifferent = value;
    this.handleVersToggle(this._versIsDifferent);
  }
  private _SOAnsprIsDifferent = false;
  get SOAnsprIsDifferent(): boolean {
    return this._SOAnsprIsDifferent;
  }
  set SOAnsprIsDifferent(value: boolean) {
    this._SOAnsprIsDifferent = value;
    this.handleSOAnsprToggle(this._SOAnsprIsDifferent);
  }

  constructor(
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private dataSvc: DataService,
    private overlayService: ExgOverlayService) {
    super();

    this.getUserSpecificTop3();
  }

  /*Exakt V2 Standard*/
  Events = new ExgApplicationEventEmitter();
  tabinstance: any;
  CaseSummary: ICaseSummaryData | any = this.dataSvc.Case.Summary.Get(this.Data.auID);

  /*Workflow & Data*/
  workflow: any[] = [
    {
      navigationName: this.getRessource('WFNav0')
      , headerText: this.getRessource('WFHeader0')
      , progress: 0
      , data: {}
      , requiredData: []
    },
    {
      navigationName: this.getRessource('WFNav1')
      , progress: 0
      , headerText: this.getRessource('WFHeader1')
      , data: {
        au_oeID_Auftraggeber: '00000000-0000-0000-0000-000000000000',
        au_oeId_Ansprechpartner: '00000000-0000-0000-0000-000000000000',
        aue_oeID_Versicherung: '00000000-0000-0000-0000-000000000000',
        aue_oeID_Versicherung_AnspPtnr: '00000000-0000-0000-0000-000000000000',
        aueSchadenNr: '',
        auMdtOKZ: '',
        auOKZ: ''
      }
      , requiredData: [
        'au_oeID_Auftraggeber',
        'auOKZ',
        'aue_oeID_Versicherung',
        'aueSchadenNr'
      ]
    },
    {
      navigationName: this.getRessource('WFNav2')
      , progress: 0
      , headerText: this.getRessource('WFHeader2')
      , data: {
        au_enmIdent_AuftragTyp: 0,
        aueAuftragsdatum: undefined,
        auBeschreibung: '',
        aueLeistungsgegenstand: ''
      }
      , requiredData: [
        'au_enmIdent_AuftragTyp',
        'auBeschreibung',
        'aueAuftragsdatum',
        'aueLeistungsgegenstand'
      ]},
    {
      navigationName: this.getRessource('WFNav3')
      , headerText: this.getRessource('WFHeader3')
      , progress: 0
      , data: {
        aue_oeID_VN: '00000000-0000-0000-0000-000000000000',
        aue_adrID_SchadenOrt: '00000000-0000-0000-0000-000000000000',
        aue_oeID_AnspPtnr: '00000000-0000-0000-0000-000000000000',
        aueSchadenDatum: undefined,
        aue_enmIdent_Versicherungsart: 0,
        aue_enmIdent_SchadenArt: 0,
        aue_enmIdent_SchadenUrsache: 0,
        aue_enmName_SchadenUrsache: 'SchadenartUrsache'
    }
      , requiredData: [
        'aue_oeID_VN',
        'aueSchadenDatum',
        'aue_enmIdent_SchadenArt'
      ]
    },
    {
      navigationName: this.getRessource('WFNav4')
      , headerText:  this.getRessource('WFHeader4')
      , progress: 0
      , data: {
        aueVersicherungSumme: undefined,
        aueWert1914: undefined,
        aueSelbstbehalt: undefined,
        aueHinweiseEntschaedigungsgrenze: '',
        aueReserveVU: undefined
      }
      , requiredData: [
        'aueSelbstbehalt',
        'aueReserveVU',
        'placeholder'
      ]
    },
    {
      navigationName: this.getRessource('WFNav5')
      , headerText: this.getRessource('WFHeader5')
      , progress: 0
      , data: {
        aue_oeID_WAnsprPtnr1: '00000000-0000-0000-0000-000000000000',
        aue_enmIdent_WAnsprPtnr1Funktion: 0,
        aue_oeID_WAnsprPtnr2: '00000000-0000-0000-0000-000000000000',
        aue_enmIdent_WAnsprPtnr2Funktion: 0,
        aue_oeID_WAnsprPtnr3: '00000000-0000-0000-0000-000000000000',
        aue_enmIdent_WAnsprPtnr3Funktion: 0,
        aue_oeID_WAnsprPtnr4: '00000000-0000-0000-0000-000000000000',
        aue_enmIdent_WAnsprPtnr4Funktion: 0,
      }
      , requiredData: []
    },
    {
      navigationName: this.getRessource('WFNav6')
      , headerText: this.getRessource('WFHeader6')
      , progress: 0
      , data: {}
      , requiredData: []
    },
  ];
  wfConfig = {
    isSavedVersion: false,
    isLoading: false,
    selectedWorkflowIndex: 0,
    wfDataAsArray: [] as any[]
  };
  private previousAueWert1914Value: number | undefined;
  private previousAueVersicherungSummeValue: number | undefined;

  insertedValuesOEs: any = {
    au_oeID_Auftraggeber: undefined,
    au_oeId_Ansprechpartner: undefined,
    aue_oeID_Versicherung: undefined,
    aue_oeID_VN: undefined,
    aue_oeID_Versicherung_AnspPtnr: undefined,
  };

  insertedAddresses: any = {
    aue_adrID_SchadenOrt: undefined,
  };

  WAnsprOEList = [
    'aue_oeID_WAnsprPtnr1',
    'aue_oeID_WAnsprPtnr2',
    'aue_oeID_WAnsprPtnr3',
    'aue_oeID_WAnsprPtnr4',
  ];

  /*Atttachments*/
  attConfig = {
    MAXFILESIZE: environment.rest.MAXFILESIZE,
    selectedFiles: [] as ExcFileItem[],
    selectedFilesChunked: [] as ExcFileItem[][],
    FILE_SIZE_UNITS: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    FILE_SIZE_UNITS_LONG: ['Bytes', 'Kilobytes', 'Megabytes', 'Gigabytes', 'Pettabytes', 'Exabytes', 'Zettabytes', 'Yottabytes'],
    dokument: {
      download: (dokID: any): void => {
        const queryParams: { [key: string]: any } = {
          dokID,
          export: true
        };
        const url = this.excRest.computeUrl('DocumentR', queryParams);
        this.excRest.get(url, { export: true }).subscribe();
      }
    },
    calcFileSize: (sizeInBytes: number, longForm: boolean = false): string => {
      const units = longForm
        ? this.attConfig.FILE_SIZE_UNITS_LONG
        : this.attConfig.FILE_SIZE_UNITS;

      const power = Math.min(Math.floor(Math.log(sizeInBytes) / Math.log(1024)), units.length - 1);
      const size = sizeInBytes / Math.pow(1024, power); // size in new units
      const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
      const unit = units[power];
      return `${formattedSize} ${unit}`;
    },
    treeControl: new NestedTreeControl<any>(node => node.documents),
  };
  attachmentJagTable = {
    state: 1,
    ready: () => {
      if (!this.CaseSummary?.attachmentJagTable.data || this.CaseSummary?.attachmentJagTable?.isEmpty) {
        this.attachmentJagTable.state = 2;
      } else {
        this.attachmentJagTable.state = 0;
      }
    },
    hasChild: (_: number, node: any): boolean => {
      return !!node.documents && node.documents.length > 0;
    }
  };

  /*OE*/
  private OEtoChangeAfterCreation = '';

  /*Address*/
  aueLeistungsgegenstandEnmList: any[] = this.appSvc.helperObj.clone(this.enumSvc.getEnumerationList('Leistungsgegenstand'));

  showTop3Auftraggeber = true;
  TOP_3_LIST: any[] = [];

  userType: number | any;
  ngOnInit(): void {
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    this.setTabLable();
    this.registerEvents();
    this.computeWFDataSummary();
    this.resetEnmValue();
    if (this.Data.auID) {
      this.workflow[0].progress = 100;
      this.getExistingCaseData(this.Data.auID);
      /*Case Summary für die Anhänge*/
      this.CaseSummary = this.dataSvc.Case.Summary.Get(this.Data.auID, undefined, {Events: this.Events});
    }
    else {
      /*completely New, Set Default Date and Enum*/
      this.changeDataFromInput('aueAuftragsdatum', new Date(), this.workflow[2]);
      this.setDefaultEnums();
    }
  }

  private resetEnmValue(): void {
    for (const enm of this.aueLeistungsgegenstandEnmList) {
      enm.enmValue = false;
    }
  }

  /*Exakt V2 Standard*/
  private setTabLable(): void {
    if (this.tabinstance && this.Data.auID && this.Data.auNr) {
      this.tabinstance.Label = this.getRessource('EditCaseAuNr', {auNr: this.Data.auNr});
      this.workflow[0].headerText = this.getRessource('EditCaseAuNr', {auNr: this.Data.auNr});
    } else {
      this.tabinstance.Label = this.getRessource('CreateCase');
      this.workflow[0].headerText = this.getRessource('CreateCase');
    }
  }

  private registerEvents(): void {
    this.Events.Case?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.attachmentJagTable.ready();
        this.wfConfig.isLoading = false;
      }
    });
    this.Events.Document?.UploadDialog?.Closed.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.attConfig.selectedFiles = [];
        this.attConfig.selectedFilesChunked = [];
        this.CaseSummary?.LoadSummary();
      }
      else {
        this.CaseSummary?.LoadSummary();
        this.modal.showToast(this.getRessource('AttNoSave'), 'md-toast', 'fas fa-exclamation');
      }
    });
    this.Events.Document?.UpdateDialog?.Closed.subscribe((evt: ExgEventArgs) => {
      if (evt?.success) {
        this.attConfig.selectedFiles = [];
        this.attConfig.selectedFilesChunked = [];
        this.CaseSummary?.LoadSummary();
      } else {
        this.CaseSummary?.LoadSummary();
      }
    });
    this.Events.OE?.NewOE?.Save?.subscribe(
      (evt: any) => {
        if (evt.success && evt.data?.oeID) {
          this.changeOE(this.OEtoChangeAfterCreation, evt.data);
        }
      }
    );
  }

  /*Data Saving & Calls*/

  private isCaseSaveable(): boolean {
    return this.workflow[1]?.data?.aue_oeID_Versicherung !== '00000000-0000-0000-0000-000000000000' &&
      !!this.workflow[1]?.data?.auOKZ                                                               &&
      !!this.workflow[2]?.data?.auBeschreibung                                                      &&
      !!this.workflow[2]?.data?.aueLeistungsgegenstand                                              &&
      this.workflow[3]?.data?.aue_oeID_VN                !== '00000000-0000-0000-0000-000000000000' &&
      this.workflow[3]?.data?.aue_enmIdent_SchadenArt !== 0                                         &&
      this.workflow[3]?.data?.aue_adrID_SchadenOrt       !== '00000000-0000-0000-0000-000000000000' &&
      !!this.workflow[3]?.data?.aueSchadenDatum                                                     &&
      !!this.workflow[2]?.data?.aueAuftragsdatum                                                    &&
      this.workflow[3]?.data?.aue_enmIdent_Versicherungsart !== 0;
  }

  async save(action: 'draft' | 'case' | 'caseAndCheck'): Promise<void> {
    /*Not Allowed CASECHECK*/
    if (action === 'caseAndCheck' && !this.excSecurity.isFeatured('CASECHECK')) {
      this.modal.showToast('Sie sind nicht berechtigt den Auftrag geprüft zu markieren!', 'md-toast', 'fas fa-exclamation');
      return;
    }
    /* Not A draft anymore */
    if (action === 'draft' && this.Data.au_enmIdent_AuftragStatus === 1) {
      this.modal.showToast('Erfassung bereits abgeschlossen', 'md-toast', 'fas fa-exclamation');
      return;
    }
    /* AG & SchadenNr are essential */
    const essentialData = this.workflow[1].data;
    if (essentialData?.au_oeID_Auftraggeber === '00000000-0000-0000-0000-000000000000' ||
      !essentialData?.aueSchadenNr) {
      this.modal.showToast('Auftraggeber und Schadennummer benötigt', 'md-toast', 'fas fa-exclamation');
      return;
    }

    /* Case saveable check */
    if (action !== 'draft' && !this.isCaseSaveable()) {
      const ret = await this.showConfirmationModal(
        'Erfassung abschließen',
        'Möchten Sie die Erfassung des Auftrags wirklich unfertig abschließen?',
        true,
        true,
        'Abschließen',
        this.enumSvc.getGlobal('Cancel')
      );

      if (!ret) {
        // Wenn der Benutzer "Nein" wählt, brich die Methode ab
        return;
      }
    }

    /* Proceed with save */
    this.wfConfig.isLoading = true;
    this.computeWFDataSummary();

    const callObj = {
      ...this.getAllDataEntriesAsObject(),
      au_enmIdent_AuftragStatus: action === 'draft' ? 0 : 1,
      auCHK: action === 'caseAndCheck',
      linkedID: this.Data.linkedID
    };

    const isEdit = !!this.Data.auID;
    const saveCall = isEdit ? this.editCaseCall : this.createCaseCall;
    saveCall.call(this, callObj, action);
  }

  private showConfirmationModal(
    title: string,
    message: string,
    showConfirmButton: boolean,
    showCancelButton: boolean,
    confirmButtonText: string,
    cancelButtonText: string
  ): Promise<boolean> {
    return new Promise((resolve) => {
      this.modal.showSimple(title, message, showConfirmButton, showCancelButton, confirmButtonText, cancelButtonText)
        .subscribe((ret: any) => {
          resolve(!!ret); // `true` bei Bestätigung, `false` bei Abbruch
        });
    });
  }

  private createCaseCall(callObj: { [key: string]: any }, action: 'draft' | 'case' | 'caseAndCheck'): void {

    const url = this.excRest.computeUrl('CaseC');

    this.excRest.post(url, callObj).subscribe((ret: any) => {
      this.handleResponse(ret, action);
    });
  }

  private editCaseCall(callObj: { [key: string]: any }, action: 'draft' | 'case' | 'caseAndCheck'): void {

    const url = this.excRest.computeUrl('CaseU', { auID: this.Data.auID });
    const editObj = { ...callObj, auUPT: this.Data.auUPT };

    this.excRest.put(url, editObj).subscribe((ret: any) => {
      this.handleResponse(ret, action);
    });
  }

  private handleResponse(ret: any, action: 'draft' | 'case' | 'caseAndCheck'): void {
    if (ret?.data?.Auftrag) {
      this.Data = ret.data.Auftrag;
      /*Case Summary für die Anhänge*/
      this.CaseSummary = this.dataSvc.Case.Summary.Get(this.Data.auID, undefined, {Events: this.Events});
      this.processValidCaseData(ret, true);

      let toastMessage: string;

      if (action === 'draft') {
        toastMessage = this.getRessource('DraftSave');
      } else if (action === 'caseAndCheck' && ret.data.Auftrag.auCKD) {
        toastMessage = this.getRessource('CaseCheck');
      } else {
        toastMessage = this.getRessource(action === 'case' ? 'CaseSave' : 'CaseDraft');
      }

      this.modal.showToast(toastMessage, 'md-toast', 'fas fa-check-circle');

      if (action === 'caseAndCheck' || action === 'case') {
        this.appSvc.Case.Workspace.OpenTabV2(ret.data.Auftrag.auID, { Events: this.Events });
        this.tabinstance.Close();
      }
    } else {
      const toastMessage = action === 'draft'
        ? this.getRessource('DraftNoSave')
        : action === 'caseAndCheck'
          ? this.getRessource('CaseNoCheck')
          : this.getRessource('CaseNoSave');

      this.modal.showToast(toastMessage, 'md-toast', 'fas fa-exclamation');
    }

    this.wfConfig.isLoading = false;
  }

  private handleVersToggle(newValue: boolean): void {
    if (!newValue) { /*Versicherung is nicht mehr different, setze Versicherung und VAnsprp. auf Auftraggeber und Ansprp. */
      this.changeOE('aue_oeID_Versicherung', this.insertedValuesOEs.au_oeID_Auftraggeber);
      this.changeOE('aue_oeID_Versicherung_AnspPtnr', this.insertedValuesOEs.au_oeId_Ansprechpartner);
    }
  }
  private handleSOAnsprToggle(newValue: boolean): void {
    if (!newValue) { /*SO Anspr is nicht mehr different, setze SO Anspr. auf VN */
      this.changeOE('aue_oeID_Versicherung', this.insertedValuesOEs.aue_oeID_VN);
    }
  }

  checkIfVersIsDifferent(): void {
    this.versIsDifferent = this.workflow[1].data.au_oeID_Auftraggeber !== this.workflow[1].data.aue_oeID_Versicherung
      || this.workflow[1].data.au_oeId_Ansprechpartner !== this.workflow[1].data.aue_oeID_Versicherung_AnspPtnr;
  }

  checkIfSOAnsprIsDifferent(): void {
    this.SOAnsprIsDifferent = this.workflow[3].data.au_oeID_VN !== this.workflow[3].data.aue_oeID_AnspPtnr;
  }

  /*Workflow Reopening*/
  private handleSpecialAttributeReopen(AttrToChange: string, wf: any, newValue: any, silent?: boolean): void {
    /*When Case is reopened this handles progress of aueWert1914 and aueVersicherungSumme*/
    /*And Leistungsgegenstand*/
    if (AttrToChange === 'aueVersicherungSumme' && newValue) {
      this.deletePlaceholderIfExist(wf, AttrToChange);
      wf.data[AttrToChange] = newValue;
      this.previousAueVersicherungSummeValue = newValue;
      if (!silent) {
        this.advanceProgress(AttrToChange, true);
      }
    }
    if (AttrToChange === 'aueWert1914' && newValue) {
      this.deletePlaceholderIfExist(wf, AttrToChange);
      wf.data[AttrToChange] = newValue;
      this.previousAueWert1914Value = newValue;
      const indexToDelete = wf.requiredData.indexOf('aueVersicherungSumme');
      if (indexToDelete !== -1) {
        wf.requiredData.splice(indexToDelete, 1); // Löscht das Element an diesem Index
        wf.requiredData.push(AttrToChange);
      }
    }
    if (AttrToChange === 'aueLeistungsgegenstand' && newValue) {
      wf.data[AttrToChange] = newValue;
      this.extractLeistungsgegenstandOnReopen();
      if (!silent) {
        this.advanceProgress(AttrToChange, true);
      }
    }
  }

  private deletePlaceholderIfExist(wf: any, AttrToChange: string): void {
    const indexToDelete = wf.requiredData.indexOf('placeholder');
    if (indexToDelete !== -1) {
      wf.requiredData.splice(indexToDelete, 1); // Löscht das Element an diesem Index
      wf.requiredData.push(AttrToChange);
    }
  }

  private getExistingCaseData(auID: string): void {
    this.wfConfig.isLoading = true;

    const url = this.excRest.computeUrl('CaseR_Summary', { auID });
    this.excRest.get(url).subscribe({
      next: (ret: any) => this.handleCaseDataResponse(ret),
      error: () => {
        this.modal.showToast(this.getRessource('CaseLoadError'), 'md-toast', 'fas fa-exclamation');
        this.wfConfig.isLoading = false;
        this.tabinstance.Close();
      }
    });
  }

  private handleCaseDataResponse(ret: any): void {
    if (ret?.data?.Auftrag && Array.isArray(ret.data.OEs)) {
      this.modal.showToast(
        this.getRessource('CaseOpen', { auNr: ret.data.Auftrag.auNr }),
        'md-toast',
        'fas fa-check-circle'
      );
      this.processValidCaseData(ret);
      this.workflow[5].progress = 100;
      this.workflow[0].progress = 100;
    } else {
      this.modal.showToast(this.getRessource('CaseNoOpen'), 'md-toast', 'fas fa-exclamation');
      this.tabinstance.Close();
    }

    if (ret?.data?.Wert1914Faktor?.setWert1914Faktor) {
      this.Data.wert1914Faktor = ret.data.Wert1914Faktor.setWert1914Faktor;
    }

    if (ret?.data?.Schadenort?.adrID) {
      this.insertedAddresses.aue_adrID_SchadenOrt = ret.data.Schadenort;
    }

    if (!ret?.data?.Auftrag?.aueAuftragsdatum) {
      this.workflow[2].data.aueAuftragsdatum = new Date();
    }
  }

  private processValidCaseData(ret: any, silent?: boolean ): void {
    this.wfConfig.isSavedVersion = true;
    this.Data.auUPT = ret.data.Auftrag.auUPT;

    this.workflow.forEach((wf: any) => {
      this.updateReopenedWorkflowData(wf, ret.data.Auftrag, ret.data.OEs, silent);
    });

    this.checkIfVersIsDifferent();
    this.checkIfSOAnsprIsDifferent();
    this.wfConfig.isLoading = false;
    this.computeWFDataSummary();
  }

  private updateReopenedWorkflowData(wf: any, auftrag: any, oes: any[], silent?: boolean): void {
    Object.entries(wf.data).forEach(([key, value]) => {
      if (auftrag[key] !== undefined) {
        this.changeDataFromReopen(key, wf, auftrag[key], silent);
        // Prüfen, ob der Schlüssel "oeid" enthält -> in TypeAhead reinstecken
        if (key.toLowerCase().includes('oeid')) {
          const matchingOE = oes.find((e: { oeID: any }) => e.oeID === auftrag[key]);

          if (matchingOE) {
            this.insertedValuesOEs[key] = matchingOE;
          }
        }
      }
    });
  }

  private changeDataFromReopen(AttrToChange: string, wf: any, newValue: any, silent?: boolean): void {
    const isSpecialAttribute = AttrToChange === 'aueWert1914' ||
                               AttrToChange === 'aueVersicherungSumme' ||
                               AttrToChange === 'aueLeistungsgegenstand';
    if (isSpecialAttribute) {
      this.handleSpecialAttributeReopen(AttrToChange, wf, newValue, silent);
      return;
    }
    if (newValue) {
      const isEmptyOE = newValue === '00000000-0000-0000-0000-000000000000';
      wf.data[AttrToChange] = newValue;
      if (!isEmptyOE && !silent) {
        this.advanceProgress(AttrToChange, true);
      }
      if (AttrToChange === 'au_oeID_Auftraggeber' && !isEmptyOE) {
        this.showTop3Auftraggeber = false;
      }
    }
  }

  /*Workflow & Data Manipulation*/
  private advanceProgress(attrToChange: string, isPositive?: boolean): void {
    this.workflow.find(( wf: any, index: number, array: any[]) => {
      if (wf.requiredData.includes(attrToChange)) {
        const lengthOfWorkflowData = wf.requiredData.length;
        if (isPositive) {
          array[index].progress += 100 / lengthOfWorkflowData; }
        else {
          array[index].progress -= 100 / lengthOfWorkflowData; }
      }
    });
  }

  private decreaseProgressAndDelete(AttrToChange: string): void {
    this.workflow.find(( data: any, index: number, array: any[]) => {
      if (data.requiredData.includes(AttrToChange)) {
        const lengthOfWorkflowData = data.requiredData.length;
        array[index].progress -= 100 / lengthOfWorkflowData;
        const indexToDelete = data.requiredData.indexOf(AttrToChange);
        if (indexToDelete !== -1) {
          data.requiredData.splice(indexToDelete, 1); // Löscht das Element an diesem Index
          data.requiredData.push('placeholder');
        }
      }
    });
  }

  navigateLeft(): void {
    if (this.wfConfig.selectedWorkflowIndex > 0) {
      this.wfConfig.selectedWorkflowIndex--;
    }
  }

  navigateRight(): void {
    if (this.wfConfig.selectedWorkflowIndex < this.workflow.length - 1) {
      this.wfConfig.selectedWorkflowIndex++;
      if (this.wfConfig.selectedWorkflowIndex === 5) { this.workflow[5].progress = 100; }
      if (this.wfConfig.selectedWorkflowIndex === 1) { this.workflow[0].progress = 100; }
    }
  }

  changeDataFromInput(AttrToChange: string, newValue: any, wf: any): void {
    /*Methode für ngmodelchange inputs im HTML*/
    const oldValue = wf.data[AttrToChange] || undefined;
    const wasFilled = !!oldValue && oldValue !== '00000000-0000-0000-0000-000000000000';
    if (wasFilled && newValue) {
      wf.data[AttrToChange] = newValue;
    }
    else if (wasFilled && !newValue) {
      wf.data[AttrToChange] = '';
      this.advanceProgress(AttrToChange, false);
    }
    else if (!wasFilled && newValue) {
      wf.data[AttrToChange] = newValue;
      this.advanceProgress(AttrToChange, true);
    }

    if (AttrToChange === 'aue_enmIdent_SchadenArt') {
      const newSchadenArtHasSelector = !!this.enumSvc.getEnumerationItem('Schadenart', newValue).enmSelector;
      const enmSelector = newSchadenArtHasSelector ? this.enumSvc.getEnumerationItem('Schadenart', newValue).enmSelector : '';
      const enmListSelector = newSchadenArtHasSelector ? this.enumSvc.getEnumerationList(enmSelector) : [];
      const selectorHasList = enmListSelector.length > 0;
      if (newSchadenArtHasSelector && selectorHasList) {
        wf.data.aue_enmName_SchadenUrsache = enmSelector;
        wf.data.aue_enmIdent_SchadenUrsache = this.enumSvc.getEnumerationDefaultValue(enmSelector) || 0;
      } else {
        wf.data.aue_enmName_SchadenUrsache = 'SchadenArtUrsache';
        wf.data.aue_enmIdent_SchadenUrsache = 0;
      }
    }
    this.wfConfig.isSavedVersion = false;
    this.computeWFDataSummary();
  }

  getLeistungsgegenstandUIString(aueLeistungsgegenstand: string): string {
    const enumList = this.enumSvc.getEnumerationList('Leistungsgegenstand');

    const identList = aueLeistungsgegenstand
      .split('|')                                    // Teile am '|'-Zeichen
      .filter((item: string) => item !== '')         // Entferne leere Einträge
      .map((item: string) => Number(item));          // Konvertiere in Zahlen

    const matchingNames = enumList
      .filter((enumItem: { enmIdent: number, enmText: string }) => identList.includes(enumItem.enmIdent))
      .map((enumItem: { enmIdent: number, enmText: string }) => enumItem.enmText);

    return matchingNames.join(';');
  }

  ngModelWorkaround(AttrToChange: string, wf: any, $event: any): void {
    const target = $event.target as HTMLInputElement;
    const currentValue = target.value === '' ? undefined : parseFloat(target.value); // Wert als Zahl oder 0
    let previousValue: number | undefined;

    if (AttrToChange === 'aueWert1914') {
      previousValue = this.previousAueWert1914Value || undefined;
      this.previousAueWert1914Value = currentValue;
    } else if (AttrToChange === 'aueVersicherungSumme') {
      previousValue = this.previousAueVersicherungSummeValue;
      this.previousAueVersicherungSummeValue = currentValue;
    }

    /*Workaround für progress und disabled attribute im Template. */
    const wasFirstLetter = previousValue === undefined && currentValue !== undefined;
    const isNowEmpty = previousValue !== undefined && currentValue === undefined;

    /*Goes here when its now empty*/
    if (isNowEmpty) {
      this.decreaseProgressAndDelete(AttrToChange);
      wf.data.aueVersicherungSumme = undefined;
      this.previousAueVersicherungSummeValue = undefined;
      wf.data.aueWert1914 = undefined;
      this.previousAueWert1914Value = undefined;
    }
    /*Goes here when its now filled*/
    else if (wasFirstLetter) {
      const indexToDelete = wf.requiredData.indexOf('placeholder');
      if (indexToDelete !== -1) {
        wf.requiredData.splice(indexToDelete, 1); // Löscht das Element an diesem Index
      }
      wf.requiredData.push(AttrToChange);
      this.advanceProgress(AttrToChange, true);
      wf.data[AttrToChange] = currentValue;
    }
    /*Make aueVersicherungssumme from Wert 1914*/
    if (AttrToChange === 'aueWert1914' && currentValue !== undefined) {
      const wert1914 = currentValue;
      const faktor = this.Data.wert1914Faktor;
      wf.data.aueVersicherungSumme = Math.round(wert1914 * faktor * 100) / 100;
      this.previousAueVersicherungSummeValue = Math.round(wert1914 * faktor * 100) / 100;
    }
  }

  computeWFDataSummary(): void {
    this.wfConfig.wfDataAsArray = this.workflow
      .map(item => Object.entries(item.data).map(([key, value]) => ({ key, value })))
      .reduce((acc, curr) => acc.concat(curr), []);
  }

  getAllDataEntriesAsObject(): { [key: string]: any } {
    return this.workflow
      .map(item => item.data)                   // Extrahiere das `data`-Objekt jedes `workflow`-Elements
      .reduce((acc, curr) => ({ ...acc, ...curr }), {}); // Füge alle key:value-Paare in ein Objekt zusammen
  }

  /*OE Manipulation & Calls*/
  private openAdvancedOEModal(predefinedCRMRolle: number = 0,
                              predefinedOETyp: number = 0, parentOEID: string
    ,                         isWAnspr: boolean, OEtoChange: string, chosenWAnspr: string
    ,                         chosenWAsnprEnum: number): void {
    this.modal.show('ModalChooseOEComponent'
      , {
        oe_CrmRolle: predefinedCRMRolle,
        oe_enmIdent_OETyp: predefinedOETyp
        , isWAnspr
        , selectedWAnsprEnmIdent: chosenWAnspr ? chosenWAsnprEnum : 0
        , parentOEID
      }).subscribe((modalResponse: any) => {
      if (modalResponse?.chosenOE) {
        this.changeOE(OEtoChange,  modalResponse.chosenOE, modalResponse.chosenWAnsprEnmIdent);
      }
    });
  }

  private getOEToastName(OEtoChange: string): string {
    const repTable = OEtoChange.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag';
    const isWAnspr = OEtoChange.startsWith('aue_oeID_WAnspr');

    let uiName = '';
    if (isWAnspr) {
      const whichWAnsprNr = OEtoChange.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
      const chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
      this.workflow.find((wf: any) => {
        if (wf.data[chosenWAnspr] || wf.data[chosenWAnspr] === 0) {
          uiName = this.enumSvc.getEnumerationText('WAnsprPtnrFunktion',
            wf.data[chosenWAnspr]);
        }
      });
    } else {
      uiName = this.enumSvc.getFieldCaption(repTable, OEtoChange);
    }
    return uiName;
  }

  private handleSuccessfulOEChange(OEtoChange: string, uiName: string, OE: any, oldOEID: string): void {
    const OEwasFilled = oldOEID !== '00000000-0000-0000-0000-000000000000';
    const OEwasDeleted = OE?.oeID === '00000000-0000-0000-0000-000000000000';
    const deleteOrChangeMsg = OEwasDeleted ? 'DeleteOE.Success' : 'ChangeOE.Success';
    const deleteObj = OEwasDeleted ? 'OEtoDelete' : 'OEtoChange';

    // Setze die Werte basierend auf dem Zustand des OEs
    this.insertedValuesOEs[OEtoChange] = OEwasDeleted ? undefined : { ...OE };
    this.updateConnectedBindings(OEtoChange, OE, OEwasDeleted);

    if (OEwasFilled === OEwasDeleted) {
      this.advanceProgress(OEtoChange, !OEwasDeleted);
    }
    if (OEtoChange === 'au_oeID_Auftraggeber') {
      this.showTop3Auftraggeber = false;
    }

    // Zeige Feedback für den Benutzer
    this.modal.showToast(
      this.getRessource(deleteOrChangeMsg, { [deleteObj]: uiName }), 'md-toast', 'fas fa-check-circle' );

    this.computeWFDataSummary();
    this.wfConfig.isSavedVersion = false;
  }

  private updateConnectedBindings(AttrToChange: string, dataObj: any, AttrWasDeleted: boolean): void {
    if (AttrToChange === 'au_oeID_Auftraggeber') {
      this.changeOE('au_oeId_Ansprechpartner', {oeID: '00000000-0000-0000-0000-000000000000'});
      if (!this.versIsDifferent) {
        this.changeOE('aue_oeID_Versicherung', AttrWasDeleted ? {oeID: '00000000-0000-0000-0000-000000000000'} : dataObj);
      }
    }

    if (AttrToChange === 'aue_oeID_Versicherung') {
      this.changeOE('aue_oeID_Versicherung_AnspPtnr', {oeID: '00000000-0000-0000-0000-000000000000'});
    }
    if (AttrToChange === 'aue_oeID_VN') {
      if (!this.SOAnsprIsDifferent) {
        this.changeOE('aue_oeID_AnspPtnr', AttrWasDeleted ? {oeID: '00000000-0000-0000-0000-000000000000'} : dataObj);
      }
    }
  }

  searchOEAdvanced(OEtoChange: string
    ,              parentOEID: string = '00000000-0000-0000-0000-000000000000'
    ,              predefinedCRMRolle: number = 0
    ,              predfinedOETyp: number = 0): void {
    const isWAnspr = OEtoChange.startsWith('aue_oeID_WAnspr');
    let chosenWAnspr = '';
    let chosenWAsnprEnum = 0;
    if (isWAnspr) {
      const whichWAnsprNr = OEtoChange.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
      chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
      this.workflow.find((wf: any) => {
        if (wf.data[chosenWAnspr]) {
          chosenWAsnprEnum = wf.data[chosenWAnspr];
        }
      });
    }
    this.openAdvancedOEModal(predefinedCRMRolle, predfinedOETyp, parentOEID, isWAnspr, OEtoChange, chosenWAnspr, chosenWAsnprEnum);
  }
  changeOE(OEtoChange: string, OE: any, chosenWAnsprEnmIdent: number = 0): void {
    const oeID = OE?.oeID || '00000000-0000-0000-0000-000000000000';
    let oldOEID = '00000000-0000-0000-0000-000000000000';

    const isWAnsprChange = OEtoChange.includes('WAnspr');
    const whichWAnsprNr = isWAnsprChange ? OEtoChange.slice(-1) : null; // Kann 1, 2, 3 oder 4 sein
    const chosenWAnspr = isWAnsprChange ? 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion' : null;

    // Workflow-Daten aktualisieren
    const oeWasChanged = this.workflow.some((wf: any, index: number) => {
      const currentValue = wf.data?.[OEtoChange];
      const hasAttributeToChange = wf.data?.hasOwnProperty(OEtoChange);
      const isDifferentValue = currentValue !== oeID;
      const isValidOeID = !!oeID;

      if (hasAttributeToChange && isValidOeID && isDifferentValue) {
        oldOEID = this.workflow[index].data[OEtoChange];
        this.workflow[index].data[OEtoChange] = oeID;

        // Aktualisiere chosenWAnspr nur, wenn isWAnsprChange true ist
        if (isWAnsprChange && chosenWAnspr && chosenWAnsprEnmIdent) {
          this.workflow[index].data[chosenWAnspr] = chosenWAnsprEnmIdent;
        }

        return true; // Änderung durchgeführt
      }
      return false;
    });

    if (oeWasChanged) {
      const uiName = this.getOEToastName(OEtoChange);
      this.handleSuccessfulOEChange(OEtoChange, uiName, OE, oldOEID);
    }
  }

  deleteOE(OEtoDelete: string): void {
    this.changeOE(OEtoDelete,  {oeID: '00000000-0000-0000-0000-000000000000'});
    if (OEtoDelete === 'au_oeID_Auftraggeber') {
      this.showTop3Auftraggeber = true;
    }
  }

  updateWAnsprRoll(WAnsprToChange: string, newEnmIdent: number): void {
    const whichWAnsprNr = WAnsprToChange.slice(-1);  /*Kann 1, 2, 3 oder 4 sein*/
    const chosenWAnspr = 'aue_enmIdent_WAnsprPtnr' + whichWAnsprNr + 'Funktion';
    const updatedOE = {
      [chosenWAnspr]: newEnmIdent
    };
    const wasEdited = this.workflow.some((wf: any) => {
      if (wf.data[chosenWAnspr] || wf.data[chosenWAnspr]  === 0) {
        wf.data[chosenWAnspr] = updatedOE[chosenWAnspr];
        return true;
      }
      return false;
    });
    if (wasEdited) {
      this.modal.showToast(
        this.getRessource('ChangeOE.Success'
          , {OEtoChange: this.enumSvc.getEnumerationText('WAnsprPtnrFunktion', newEnmIdent) })
        , 'md-toast', 'fas fa-check-circle');
      this.computeWFDataSummary();
      this.wfConfig.isSavedVersion = false;
    } else {
      this.modal.showToast(
        this.getRessource('ChangeOE.Failure'
          , {OEtoChange: this.enumSvc.getEnumerationText('WAnsprPtnrFunktion', newEnmIdent)})
        , 'md-toast', 'fas fa-check-circle');
    }
  }

  openNewOEModal(OEtoChange: string
          ,      oeIDparent: string = '00000000-0000-0000-0000-000000000000'
          ,      isCompany: boolean = false
          ,      predefinedOECrmRolle?: number
          ,      predefinedOETyp?: number): void {
    this.OEtoChangeAfterCreation = OEtoChange;
    this.appSvc.OE.OeEditor.OpenModal({
        isNew: true
        , showAssignButton: true
        , isCompany
        , oeIDparent
        , predefinedCrmRolle: predefinedOECrmRolle
        , predefinedEnmIdentOETyp: predefinedOETyp
      }
      , {Events: this.Events});
  }

  getCorrespondingOeID(key: string): string {
    // Regex, um die Zahl am Ende des enmIdent-Keys zu extrahieren
    const match = key.match(/aue_enmIdent_WAnsprPtnr(\d+)Funktion/);
    // Wenn keine Zahl gefunden wird, gibt es keinen entsprechenden oeID-Key
    if (!match) {
      return '';
    }
    // Die extrahierte Zahl (Index) aus dem enmIdent-Key
    const index = match[1];
    return `aue_oeID_WAnsprPtnr${index}`;
  }

  /*Atttachments*/
  onFilesSelect(files: ExcFileItem): void {
    this.attConfig.selectedFiles = this.attConfig.selectedFiles.concat(files);
    this.appSvc.Document.Upload.OpenModalv2({dok_objID: this.Data.auID, selectedFiles: this.attConfig.selectedFiles}
    , { Events: this.Events});
  }

  showAttachmentUpdateModal(dokID: string): void {
    this.appSvc.Document.Update.OpenModal({ dokID }, { Events: this.Events });
  }

  onFilesSelectChunked(event: any[]): void {
    for (const eventElement of event) {
      this.attConfig.selectedFilesChunked.push(eventElement);
    }
  }

  openAttachmentInBrowser(document: any): void{
    if (document.dokMIME.includes('/pdf') || document.dokMIME.includes('image/')) {
      this.appSvc.file.dokument.openInBrowser(document.dokID);
    }
    else {
      this.modal.showToast(this.getRessource('OpenInBrowser.NotOpenInBrowser'), 'md-toast', 'fas fa-exclamation');
    }
  }

  downloadAttachment(dokID: string): void {
    this.appSvc.file.dokument.download(dokID);
  }

  openFilePreview(dokID: any): void {
    this.appSvc.Document.Preview.OpenModal({objID: this.CaseSummary?.ID, attID: dokID}, {Events: this.Events});
  }

  openDocumentUploadModal(): void {
    this.appSvc.Document.Upload.OpenModalv2({dok_objID: this.CaseSummary?.ID}, {Events: this.Events});
  }

  private getAdrToastName(adrToChange: string): string {
    const repTable = adrToChange.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag';

    let uiName = '';
    uiName = this.enumSvc.getFieldCaption(repTable, adrToChange);
    return uiName;
  }

  private handleSuccessfulAdrChange(adrtoChange: any, uiName: string, data: any, oldAdrID: string): void {
    const adrWasFilled = oldAdrID !== '00000000-0000-0000-0000-000000000000';
    const adrWasDeleted = data?.adrID === '00000000-0000-0000-0000-000000000000';
    const deleteOrChangeMsg = adrWasDeleted ? 'DeleteAdr.Success' : 'ChangeAdr.Success';
    const deleteObj = adrWasDeleted ? 'AdrtoDelete' : 'AdrtoChange';

    this.insertedAddresses[adrtoChange] = adrWasDeleted ? undefined : { ...data };
    this.updateConnectedBindings(adrtoChange, data, adrWasDeleted);

    if (adrWasFilled === adrWasDeleted) {
      this.advanceProgress(adrtoChange, !adrWasDeleted);
    }

    this.modal.showToast(
      this.getRessource(deleteOrChangeMsg, { [deleteObj]: uiName }), 'md-toast', 'fas fa-check-circle' );

    this.computeWFDataSummary();
    this.wfConfig.isSavedVersion = false;
  }

  openNewAdrModal(adrToChange: string, parentOEID: string = '00000000-0000-0000-0000-000000000000'): void {
    this.modal.show('ModalLocationCreateComponent', {new: true, adr_enmIdent_AdresseTyp: 5}, true).subscribe(data => {
      if (data) {
        const URL = this.excRest.computeUrl('OeAdresseC_Schadenort', {oeID: parentOEID});
        this.excRest.post(URL, data).subscribe((ret: any) => {
          if (ret?.data?.Schadenort) {
            this.changeAddress(adrToChange, ret.data.Schadenort);
          }
        });
      }
    });
  }

  changeAddress(adrToChange: string, data: any): void {
    const adrID = data?.adrID || '00000000-0000-0000-0000-000000000000';
    let oldAdrID = '00000000-0000-0000-0000-000000000000';
    // Workflow-Daten aktualisieren
    const adrWasChanged = this.workflow.some((wf: any, index: number) => {
      const currentValue = wf.data?.[adrToChange];
      const hasAttributeToChange = wf.data?.hasOwnProperty(adrToChange);
      const isDifferentValue = currentValue !== adrID;
      const isValidAdrID = !!adrID;

      if (hasAttributeToChange && isValidAdrID && isDifferentValue) {
        oldAdrID = this.workflow[index].data[adrToChange];
        this.workflow[index].data[adrToChange] = adrID;

        return true;
      }
      return false;
    });

    if (adrWasChanged) {
      const uiName = this.getAdrToastName(adrToChange);
      this.handleSuccessfulAdrChange(adrToChange, uiName, data, oldAdrID);
    }
  }

  deleteAdr(adrKey: string): void {
    this.changeAddress(adrKey, {adrID: '00000000-0000-0000-0000-000000000000'});
  }

  computeAueLeistungsgegenstand(): void {
    this.wfConfig.isSavedVersion = false;
    const previousAueLeistungsgegenstand = this.workflow[2].data.aueLeistungsgegenstand;
    if (this.aueLeistungsgegenstandEnmList?.length > 0) {
      const chosenEnumsArray: any[] = [];
      this.aueLeistungsgegenstandEnmList.forEach((item: any) => {
        if (item?.enmValue) {
          chosenEnumsArray.push(item.enmIdent);
        }
      });

      let newAueLeistungsgegenstand = '';
      if (chosenEnumsArray.length > 0) {
        newAueLeistungsgegenstand = `|${chosenEnumsArray.join('||')}|`;
      }

      // Prüfe auf Änderungen
      const wasEmpty = !previousAueLeistungsgegenstand;
      const isEmpty = !newAueLeistungsgegenstand;

      if (wasEmpty && !isEmpty) {
        // Fall: vorher leer, jetzt befüllt → Fortschritt erhöhen
        this.advanceProgress('aueLeistungsgegenstand', true);
      } else if (!wasEmpty && isEmpty) {
        // Fall: vorher befüllt, jetzt leer → Fortschritt reduzieren
        this.advanceProgress('aueLeistungsgegenstand', false);
      }

      // Wert aktualisieren
      this.workflow[2].data.aueLeistungsgegenstand = newAueLeistungsgegenstand;

      this.computeWFDataSummary();
    }
  }


  private extractLeistungsgegenstandOnReopen(): void {
    if (this.workflow[2]?.data?.aueLeistungsgegenstand) {
      // Extrahiere die durch || getrennten enmIdent-Werte aus der Zeichenkette
      const enmIdentsString: string = this.workflow[2].data.aueLeistungsgegenstand;
      const enmIdentsArray: string[] = enmIdentsString
                                       .slice(1, -1) // Entferne die führenden und endenden "|"
                                       .split('||') // Splitte anhand von "||"
                                       .filter((ident) => ident); // Entferne eventuell leere Einträge

      if (this.aueLeistungsgegenstandEnmList?.length > 0) {
        this.aueLeistungsgegenstandEnmList.forEach((item: any) => {
          item.enmValue = enmIdentsArray.includes(String(item.enmIdent));
        });
      }
    }
  }

  private getUserSpecificTop3(): void {
    const user = this.excSecurity.CurrentUser;
    const faAttributes = user?.faAttributes || '';
    const exconID = '42B21CDC-32E4-4C1B-9184-B60653FD171D';

    const match = faAttributes.match(/mdtID:([A-F0-9-]+)/i);

    if (match && match[1] === exconID) {
      this.loadTop3Exc();
    } else {
      this.TOP_3_LIST = [];
      this.showTop3Auftraggeber = false;
    }
  }

  async loadTop3Exc(): Promise<void> {
    try {
      const module = await import('./EXC_TOP3');
      this.TOP_3_LIST = module.TOP_3;
    } catch (error) {
      this.TOP_3_LIST = [];
      this.showTop3Auftraggeber = false;
    }
  }

  showPDFEditorOverlay(dokID: any, disabled: boolean): void {
    if (disabled) {
      this.overlayService.show('OverlayPdfEditorComponent', {dokID, objID: this.Data.auID, Events: this.Events}).subscribe(() => {});
    }
  }

  deleteAttachment(node: any): void {
    if ((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1) {
      this.modal.showSimple(
        this.getRessource('DeleteDocument.Title'),
        this.getRessource('DeleteDocument.Message'),
        true,
        true,
        this.getGlobal('Delete'),
        this.getGlobal('Cancel'),
      ).subscribe((rtVal: boolean) => {
        if (rtVal) {
          this.excRest
            .put(this.excRest.computeUrl('DocumentD', {dokID: node.dokID}), {})
            .subscribe((ret: any) => {
              if (ret) {
                this.modal
                  .showToast(
                    ret.success ? `${this.getRessource('DeleteDocument.success')}` : this.getRessource('DeleteDocument.fail')
                    , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                    , ret.success ? 'fa-duotone fa-trash-can-check' : 'fa-regular fa-times-circle');
                this.CaseSummary?.LoadSummary();
              }
            });
        }
      });
    }
  }

  addAttachmentToReceipts(): void {
    this.modal.showToast(this.getRessource('NoAddToReceiptAllowed'), 'md-toast', 'fas fa-exclamation');
  }

  private setDefaultEnums(): void {
    /*AuftragTyp als Semi Required braucht changeDataFromInput wg. Progress*/
    this.changeDataFromInput('au_enmIdent_AuftragTyp', this.enumSvc.getEnumerationDefaultItem('AuftragTyp').enmIdent, this.workflow[2]);
    this.workflow[3].data.aue_enmIdent_Versicherungsart = this.enumSvc.getEnumerationDefaultItem('Versicherungsart').enmIdent;
    this.workflow[3].data.aue_enmIdent_SchadenArt = this.enumSvc.getEnumerationDefaultItem('Schadenart').enmIdent;
    const enmNameUrsache = this.enumSvc.getEnumerationDefaultItem('Schadenart').enmSelector;
    this.workflow[3].data.aue_enmName_SchadenUrsache = enmNameUrsache;
    this.workflow[3].data.aue_enmIdent_SchadenUrsache = this.enumSvc.getEnumerationDefaultItem(enmNameUrsache).enmIdent;
  }
}
